import type { FaireProductEntity } from "../../entity_types/product";

export const p_qsx3pmmk2h: FaireProductEntity = {
  token: "p_qsx3pmmk2h",
  type: "product",
  name: "Awesome Coffee Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/1eb60b8ac46fa29a32e2b3385f0fa84c742f1d02948e392ef97296476eaf3312.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7586ff46e42813ba17156f38fe48340aed9636cf4bd02d3e7b651dffa7ceb638.jpeg",
    "https://cdn.faire.com/fastly/4559570f49faa46e52ccc7d096f0abad1cdd23410cc77f49ad511895b27e9353.jpeg",
    "https://cdn.faire.com/fastly/c328a227ad63c2f541fc70a4fc77c14848803133f7674fec3184e8a459b1e4b9.jpeg",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a reminder that someone is seen. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:35.663Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
